var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/util/league-claims-api-fetcher.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
var resolveUrl = (url, queryParams = {}, pathParams = {}) => {
  let query = new URLSearchParams(queryParams).toString();
  if (query)
    query = `?${query}`;
  return url.replace(/\{\w*\}/g, (key) => pathParams[key.slice(1, -1)]) + query;
};
function leagueClaimsFetch(_0) {
  return __async(this, arguments, function* ({
    url,
    method,
    body,
    headers,
    pathParams,
    queryParams,
    signal
  }) {
    var _a;
    try {
      const requestHeaders = __spreadValues({
        "Content-Type": "application/json"
      }, headers);
      if (requestHeaders["Content-Type"].toLowerCase().includes("multipart/form-data")) {
        delete requestHeaders["Content-Type"];
      }
      let responseBody;
      if (body instanceof FormData) {
        responseBody = body;
      } else {
        responseBody = JSON.stringify(body);
      }
      const response = yield leagueFetch(
        resolveUrl(url, queryParams, pathParams),
        {
          signal,
          method: method.toUpperCase(),
          body: responseBody,
          headers: requestHeaders
        }
      );
      if (!response.ok) {
        let error;
        try {
          error = yield response.json();
        } catch (e) {
          error = {
            status: "unknown",
            payload: e instanceof Error ? `Unexpected error (${e.message})` : "Unexpected error"
          };
        }
        throw error;
      }
      if ((_a = response.headers.get("content-type")) == null ? void 0 : _a.includes("json")) {
        const jsonResponse = yield response.json();
        return jsonResponse;
      }
      return yield response.blob();
    } catch (e) {
      const errorObject = {
        name: "unknown",
        message: e instanceof Error ? `Network error (${e.message})` : "Network error",
        stack: e
      };
      throw errorObject;
    }
  });
}

// src/generated/leagueClaimsComponents.ts
var postClaimsSearches = (variables, signal) => leagueClaimsFetch(__spreadProps(__spreadValues({ url: "/v1/claims-searches", method: "post" }, variables), { signal }));
var postClaimsSearchesV2 = (variables, signal) => leagueClaimsFetch(__spreadProps(__spreadValues({ url: "/v2/claims-searches", method: "post" }, variables), { signal }));
var getClaimsFilters = (variables, signal) => leagueClaimsFetch(__spreadProps(__spreadValues({ url: "/v1/claims-filters", method: "get" }, variables), { signal }));
var getClaimsFiltersV2 = (variables, signal) => leagueClaimsFetch(__spreadProps(__spreadValues({ url: "/v2/claims-filters", method: "get" }, variables), { signal }));
var getClaimDetails = (variables, signal) => leagueClaimsFetch(__spreadProps(__spreadValues({ url: "/v1/claims/{claimId}", method: "get" }, variables), { signal }));
var getClaimsSummary = (variables, signal) => leagueClaimsFetch(__spreadProps(__spreadValues({ url: "/v1/claims-summary", method: "get" }, variables), { signal }));
var getDownloadClaimsSummary = (variables, signal) => leagueClaimsFetch(__spreadProps(__spreadValues({
  url: "/v1/download-claims-summary",
  method: "get"
}, variables), {
  signal
}));
var getClaimsSummaryFile = (variables, signal) => leagueClaimsFetch(__spreadProps(__spreadValues({ url: "/v1/claims-summary-file", method: "get" }, variables), { signal }));
var getClaimEobFile = (variables, signal) => leagueClaimsFetch(__spreadProps(__spreadValues({
  url: "/v1/claim-eob-file/{claimId}",
  method: "get"
}, variables), {
  signal
}));
var operationsByTag = {
  claims: {
    postClaimsSearches,
    postClaimsSearchesV2,
    getClaimsFilters,
    getClaimsFiltersV2,
    getClaimDetails,
    getClaimsSummary,
    getDownloadClaimsSummary,
    getClaimsSummaryFile,
    getClaimEobFile
  }
};

// src/get-claims-summary.ts
import { deserialise } from "kitsu-core";

// src/util/to-title-case.util.ts
function toTitleCase(str) {
  return str.toLowerCase().split(" ").map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(" ");
}

// src/get-claims-summary.ts
var GET_CLAIMS_SUMMARY_PATH = "/v1/claims-summary";
function getDeserializedClaimsSummary(variables) {
  return __async(this, null, function* () {
    const response = yield getClaimsSummary(variables);
    const deserialisedResponse = deserialise(response);
    const claimsData = deserialisedResponse.data.claims.data;
    const normalizedClaimsData = claimsData.map((claim) => __spreadProps(__spreadValues({}, claim), {
      providerName: toTitleCase(claim.providerName)
    }));
    return { claims: normalizedClaimsData };
  });
}

// src/mocks/get-claims-summary.mock.ts
import { deserialise as deserialise2 } from "kitsu-core";
var GET_CLAIMS_SUMMARY_MOCK_DATA = {
  data: {
    attributes: {},
    id: "20dc903a-4901-4b7b-8265-031941901a46",
    relationships: {
      claims: {
        data: [
          { id: "CLM-001", type: "claims-summary-entry" },
          { id: "CLM-002", type: "claims-summary-entry" },
          { id: "CLM-003", type: "claims-summary-entry" },
          { id: "CLM-004", type: "claims-summary-entry" },
          { id: "CLM-005", type: "claims-summary-entry" },
          { id: "CLM-006", type: "claims-summary-entry" },
          { id: "CLM-007", type: "claims-summary-entry" },
          { id: "CLM-008", type: "claims-summary-entry" },
          { id: "CLM-009", type: "claims-summary-entry" },
          { id: "CLM-010", type: "claims-summary-entry" },
          { id: "CLM-011", type: "claims-summary-entry" },
          { id: "CLM-012", type: "claims-summary-entry" },
          { id: "CLM-013", type: "claims-summary-entry" },
          { id: "CLM-014", type: "claims-summary-entry" },
          { id: "CLM-015", type: "claims-summary-entry" },
          { id: "CLM-016", type: "claims-summary-entry" },
          { id: "CLM-017", type: "claims-summary-entry" },
          { id: "CLM-018", type: "claims-summary-entry" },
          { id: "CLM-019", type: "claims-summary-entry" },
          { id: "CLM-020", type: "claims-summary-entry" },
          { id: "CLM-021", type: "claims-summary-entry" },
          { id: "CLM-022", type: "claims-summary-entry" },
          { id: "CLM-023", type: "claims-summary-entry" },
          { id: "CLM-024", type: "claims-summary-entry" },
          { id: "CLM-025", type: "claims-summary-entry" },
          { id: "CLM-026", type: "claims-summary-entry" },
          { id: "CLM-027", type: "claims-summary-entry" },
          { id: "CLM-028", type: "claims-summary-entry" },
          { id: "CLM-029", type: "claims-summary-entry" },
          { id: "CLM-030", type: "claims-summary-entry" }
        ]
      }
    },
    type: "claims-summary"
  },
  included: [
    {
      attributes: {
        identifier: "CLM-001",
        owed: { amount: 61, currencyCode: "USD" },
        patientName: "Shuri",
        providerName: "Dr. Evan Swann",
        relationship: "dependent",
        serviceDate: "2021-11-25T03:03:49Z",
        status: "adjusted",
        total: { amount: 1221, currencyCode: "USD" },
        type: "pharmacy"
      },
      id: "CLM-001",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2021-05-10T11:03:22Z",
        identifier: "CLM-002",
        patientName: "Erik Selvig",
        providerName: "Dr. Tanya Andersson",
        relationship: "subscriber",
        serviceDate: "2021-10-11T05:15:32Z",
        status: "not_covered",
        total: { amount: 2192, currencyCode: "USD" },
        type: "pharmacy"
      },
      id: "CLM-002",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2022-01-17T01:48:24Z",
        identifier: "CLM-003",
        patientName: "Natalia Romanova",
        providerName: "Dr. Jane Foster",
        relationship: "spouse",
        serviceDate: "2022-04-13T18:00:20Z",
        status: "adjusted",
        total: { amount: 2891, currencyCode: "USD" },
        type: "vision"
      },
      id: "CLM-003",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2023-01-15T05:12:04Z",
        identifier: "CLM-004",
        patientName: "Hank Pym",
        providerName: "Dr. Bill Foster",
        relationship: "subscriber",
        serviceDate: "2021-09-17T18:15:54Z",
        status: "not_covered",
        total: { amount: 316, currencyCode: "USD" },
        type: "vision"
      },
      id: "CLM-004",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-005",
        patientName: "Peter Parker",
        providerName: "Dr. Leonard Samson",
        relationship: "dependent",
        serviceDate: "2022-10-11T11:53:14Z",
        status: "not_covered",
        total: { amount: 3836, currencyCode: "USD" },
        type: "vision"
      },
      id: "CLM-005",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2022-01-20T22:58:18Z",
        identifier: "CLM-006",
        owed: { amount: 226, currencyCode: "USD" },
        patientName: "Bruce Banner",
        providerName: "Dr. Reed Richards",
        relationship: "dependent",
        serviceDate: "2022-08-01T21:19:40Z",
        status: "partially_paid",
        total: { amount: 3765, currencyCode: "USD" },
        type: "pharmacy"
      },
      id: "CLM-006",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2022-06-02T08:00:44Z",
        identifier: "CLM-007",
        owed: { amount: 561, currencyCode: "USD" },
        patientName: "Luke Cage",
        providerName: "Dr. Donald Blake",
        relationship: "dependent",
        serviceDate: "2021-10-16T02:26:48Z",
        status: "adjusted",
        total: { amount: 635, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-007",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2022-10-26T18:02:02Z",
        identifier: "CLM-008",
        owed: { amount: 632, currencyCode: "USD" },
        patientName: "Foggy Nelson",
        providerName: "Dr. Hank McCoy",
        relationship: "dependent",
        serviceDate: "2022-06-28T00:38:01Z",
        status: "pending",
        total: { amount: 1848, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-008",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-009",
        owed: { amount: 274, currencyCode: "USD" },
        patientName: "Luke Cage",
        providerName: "Dr. Michael Morbius",
        relationship: "subscriber",
        serviceDate: "2021-09-13T01:25:00Z",
        status: "pending",
        total: { amount: 2186, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-009",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-010",
        patientName: "Loki Laufeyson",
        providerName: "Dr. Tanya Andersson",
        relationship: "dependent",
        serviceDate: "2021-09-22T18:32:08Z",
        status: "pending",
        total: { amount: 565, currencyCode: "USD" },
        type: "medical"
      },
      id: "CLM-010",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2021-11-17T20:45:18Z",
        identifier: "CLM-011",
        owed: { amount: 93, currencyCode: "USD" },
        patientName: "Maria Hill",
        providerName: "Dr. Henry Pym",
        relationship: "dependent",
        serviceDate: "2023-03-29T18:07:50Z",
        status: "approved",
        total: { amount: 4406, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-011",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2022-01-27T08:12:06Z",
        identifier: "CLM-012",
        patientName: "James Rhodes",
        providerName: "Dr. Tony Stark",
        relationship: "dependent",
        serviceDate: "2023-02-17T16:47:38Z",
        status: "partially_paid",
        total: { amount: 2407, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-012",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2022-09-13T18:44:15Z",
        identifier: "CLM-013",
        patientName: "Pietro Maximoff",
        providerName: "Dr. Tanya Andersson",
        relationship: "spouse",
        serviceDate: "2021-05-24T00:47:30Z",
        status: "pending",
        total: { amount: 4705, currencyCode: "USD" },
        type: "pharmacy"
      },
      id: "CLM-013",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2022-04-20T20:07:14Z",
        identifier: "CLM-014",
        owed: { amount: 626, currencyCode: "USD" },
        patientName: "Stephen Strange",
        providerName: "Dr. Bill Foster",
        relationship: "spouse",
        serviceDate: "2022-08-01T03:36:42Z",
        status: "not_covered",
        total: { amount: 2709, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-014",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-015",
        patientName: "Hank Pym",
        providerName: "Dr. Bill Foster",
        relationship: "dependent",
        serviceDate: "2022-12-09T16:18:06Z",
        status: "partially_paid",
        total: { amount: 1157, currencyCode: "USD" },
        type: "vision"
      },
      id: "CLM-015",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2023-04-16T13:27:48Z",
        identifier: "CLM-016",
        patientName: "James Rhodes",
        providerName: "Dr. Arnold Brock",
        relationship: "subscriber",
        serviceDate: "2022-02-16T23:09:53Z",
        status: "pending",
        total: { amount: 2881, currencyCode: "USD" },
        type: "vision"
      },
      id: "CLM-016",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-017",
        patientName: "Steven Rogers",
        providerName: "Dr. Donald Blake",
        relationship: "spouse",
        serviceDate: "2021-11-05T03:15:11Z",
        status: "pending",
        total: { amount: 1439, currencyCode: "USD" },
        type: "pharmacy"
      },
      id: "CLM-017",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-018",
        patientName: "Janet Van Dyne",
        providerName: "Dr. Amadeus Cho",
        relationship: "subscriber",
        serviceDate: "2021-07-17T08:19:08Z",
        status: "pending",
        total: { amount: 3526, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-018",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2022-09-05T01:15:54Z",
        identifier: "CLM-019",
        owed: { amount: 761, currencyCode: "USD" },
        patientName: "Thor Odinson",
        providerName: "Dr. Stephen Strange",
        relationship: "subscriber",
        serviceDate: "2022-01-12T05:26:52Z",
        status: "adjusted",
        total: { amount: 1809, currencyCode: "USD" },
        type: "medical"
      },
      id: "CLM-019",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-020",
        patientName: "Clint Barton",
        providerName: "Dr. William Kincaid",
        relationship: "dependent",
        serviceDate: "2022-05-21T05:40:38Z",
        status: "adjusted",
        total: { amount: 4702, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-020",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2021-04-27T21:27:13Z",
        identifier: "CLM-021",
        owed: { amount: 730, currencyCode: "USD" },
        patientName: "Hank Pym",
        providerName: "Dr. Hank McCoy",
        relationship: "dependent",
        serviceDate: "2023-04-19T01:27:16Z",
        status: "adjusted",
        total: { amount: 51, currencyCode: "USD" },
        type: "pharmacy"
      },
      id: "CLM-021",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-022",
        patientName: "Hope Van Dyne",
        providerName: "Dr. Calvin Zabo",
        relationship: "dependent",
        serviceDate: "2021-06-18T09:10:29Z",
        status: "adjusted",
        total: { amount: 1850, currencyCode: "USD" },
        type: "vision"
      },
      id: "CLM-022",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-023",
        owed: { amount: 772, currencyCode: "USD" },
        patientName: "Hank Pym",
        providerName: "Dr. Henry Pym",
        relationship: "spouse",
        serviceDate: "2022-07-25T11:01:12Z",
        status: "adjusted",
        total: { amount: 1072, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-023",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-024",
        patientName: "T'Challa",
        providerName: "Dr. Joanna Reyes",
        relationship: "dependent",
        serviceDate: "2021-11-20T16:38:55Z",
        status: "partially_paid",
        total: { amount: 3460, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-024",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2022-02-17T20:25:00Z",
        identifier: "CLM-025",
        owed: { amount: 728, currencyCode: "USD" },
        patientName: "Misty Knight",
        providerName: "Dr. James Bradley",
        relationship: "subscriber",
        serviceDate: "2022-04-13T10:39:49Z",
        status: "adjusted",
        total: { amount: 990, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-025",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2023-03-25T09:14:17Z",
        identifier: "CLM-026",
        patientName: "Carol Danvers",
        providerName: "Dr. Victor von Doom",
        relationship: "subscriber",
        serviceDate: "2021-11-12T02:33:37Z",
        status: "adjusted",
        total: { amount: 3486, currencyCode: "USD" },
        type: "pharmacy"
      },
      id: "CLM-026",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-027",
        patientName: "Hank Pym",
        providerName: "Dr. Ted Sallis",
        relationship: "subscriber",
        serviceDate: "2022-02-23T16:58:43Z",
        status: "approved",
        total: { amount: 4923, currencyCode: "USD" },
        type: "medical"
      },
      id: "CLM-027",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-028",
        owed: { amount: 493, currencyCode: "USD" },
        patientName: "Pietro Maximoff",
        providerName: "Dr. Samson Radionovich",
        relationship: "dependent",
        serviceDate: "2021-05-17T02:42:31Z",
        status: "partially_paid",
        total: { amount: 189, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-028",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        createdDate: "2021-07-23T16:49:23Z",
        identifier: "CLM-029",
        owed: { amount: 414, currencyCode: "USD" },
        patientName: "Pietro Maximoff",
        providerName: "Dr. Leonard Samson",
        relationship: "spouse",
        serviceDate: "2022-04-21T16:10:13Z",
        status: "not_covered",
        total: { amount: 3798, currencyCode: "USD" },
        type: "dental"
      },
      id: "CLM-029",
      links: { self: "" },
      type: "claims-summary-entry"
    },
    {
      attributes: {
        identifier: "CLM-030",
        patientName: "Bruce Banner",
        providerName: "Dr. Michael Morbius",
        relationship: "spouse",
        serviceDate: "2022-09-15T12:23:01Z",
        status: "not_covered",
        total: { amount: 4397, currencyCode: "USD" },
        type: "medical"
      },
      id: "CLM-030",
      links: { self: "" },
      type: "claims-summary-entry"
    }
  ]
};
var GET_CLAIMS_SUMMARY_MOCK_DATA_EMPTY = {
  data: {
    attributes: {},
    id: "20dc903a-4901-4b7b-8265-031941901a47",
    relationships: {
      claims: {
        data: []
      }
    }
  },
  included: []
};
var deserialisedGetClaimsSummaryData = deserialise2(
  GET_CLAIMS_SUMMARY_MOCK_DATA
);
var getClaimsSummaryMock = {
  claims: deserialisedGetClaimsSummaryData.data.claims.data
};

// src/mocks/get-claim-details.mock.ts
var GET_CLAIM_DETAILS_MOCK_DATA = {
  attributes: {
    createdDate: "2023-01-01T00:00:00Z",
    groupId: "123456",
    identifier: "claim-01",
    patientName: "patient test",
    providerName: "provider test",
    providerServiceNetwork: "in-network",
    serviceDate: "2023-02-01T00:00:00Z",
    paidDate: "2023-03-10T00:00:00Z",
    services: [
      {
        charged: {
          amount: 16,
          currencyCode: "USD"
        },
        memberDiscount: {
          amount: 17,
          currencyCode: "USD"
        },
        owed: {
          total: {
            amount: 18,
            currencyCode: "USD"
          }
        },
        planPaid: {
          amount: 19,
          currencyCode: "USD"
        },
        otherInsurancePaid: {
          amount: 20,
          currencyCode: "USD"
        },
        code: "12345",
        rejectionDetails: {
          code: "test-code",
          description: "test-description"
        },
        serviceDate: "2023-02-03T00:00:00Z",
        name: "Surgery"
      },
      {
        charged: {
          amount: 161,
          currencyCode: "USD"
        },
        memberDiscount: {
          amount: 171,
          currencyCode: "USD"
        },
        owed: {
          total: {
            amount: 181,
            currencyCode: "USD"
          }
        },
        planPaid: {
          amount: 191,
          currencyCode: "USD"
        },
        otherInsurancePaid: {
          amount: 201,
          currencyCode: "USD"
        },
        code: "123456",
        rejectionDetails: {
          code: "test-code 2",
          description: "test-description 2"
        },
        serviceDate: "2023-02-04T00:00:00Z",
        name: "Surgery"
      }
    ],
    status: "not_covered",
    totals: {
      charged: {
        amount: 177,
        currencyCode: "USD"
      },
      memberDiscount: {
        amount: 188,
        currencyCode: "USD"
      },
      owed: {
        amount: 199,
        currencyCode: "USD"
      },
      planPaid: {
        amount: 210,
        currencyCode: "USD"
      },
      otherInsurancePaid: {
        amount: 221,
        currencyCode: "USD"
      }
    },
    claimType: "oral"
  },
  id: "2f0d2a7b-3794-46df-8fab-bbac04c6e1b4",
  type: "claim-details"
};

// src/get-download-claims-summary.ts
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
import { downloadBlobAsFile } from "@leagueplatform/web-common";

// src/util/get-filename-from-headers.util.ts
function getFilenameFromHeaders(headers, fallbackFilename) {
  const contentDisposition = headers.get("Content-Disposition");
  const [, filename] = (contentDisposition == null ? void 0 : contentDisposition.match(
    /attachment; filename=(.*)/
  )) || [null, fallbackFilename];
  if (!filename) {
    throw new Error("Attachment filename not found");
  }
  return filename;
}

// src/get-download-claims-summary.ts
var FALLBACK_FILENAME = "claim-summary.xls";
var GET_DOWNLOAD_CLAIMS_SUMMARY_PATH = "/v1/claims-summary-file";
function getDownloadClaimsSummaryBlobAsFile(startDate, endDate, claimType, userId) {
  return __async(this, null, function* () {
    const queryParams = {
      "filter[startDate]": startDate,
      "filter[endDate]": endDate
    };
    if (claimType) {
      queryParams["filter[claimType]"] = claimType;
    }
    if (userId) {
      queryParams.userId = userId;
    }
    const queryString = new URLSearchParams(queryParams).toString();
    const response = yield leagueFetch2(
      `${GET_DOWNLOAD_CLAIMS_SUMMARY_PATH}?${queryString}`
    );
    if (!response.ok) {
      throw new Error(`getDownloadClaimsSummary error: ${response.status}`);
    }
    const filename = getFilenameFromHeaders(response.headers, FALLBACK_FILENAME);
    const blob = yield response.blob();
    downloadBlobAsFile(blob, filename);
    return response;
  });
}

// src/get-claim-details.ts
import { deserialise as deserialise3 } from "kitsu-core";
var GET_CLAIM_DETAILS_PATH = "/v1/claims";
function getDeserializedClaimDetails(variables) {
  return __async(this, null, function* () {
    const response = yield getClaimDetails(variables);
    const deserialiseClaimDetailsData = deserialise3(
      response
    );
    return __spreadValues(__spreadValues({}, deserialiseClaimDetailsData.data), deserialiseClaimDetailsData.meta);
  });
}

// src/get-download-explanation-of-benefits.ts
import { leagueFetch as leagueFetch3 } from "@leagueplatform/league-fetch";
import { downloadBlobAsFile as downloadBlobAsFile2 } from "@leagueplatform/web-common";
var FALLBACK_FILENAME2 = "explanation-of-benefits.xls";
var GET_DOWNLOAD_EXPLANATION_OF_BENEFITS_PATH = "v1/claim-eob-file/";
function getDownloadExplanationOfBenefits(variables) {
  return __async(this, null, function* () {
    var _a;
    let path = `${GET_DOWNLOAD_EXPLANATION_OF_BENEFITS_PATH}${variables.pathParams.claimId}`;
    if ((_a = variables.queryParams) == null ? void 0 : _a.userId) {
      path += `?userId=${variables.queryParams.userId}`;
    }
    const response = yield leagueFetch3(path);
    if (!response.ok) {
      throw new Error(
        `getDownloadExplanationOfBenefits error: ${response.status}`
      );
    }
    const filename = getFilenameFromHeaders(response.headers, FALLBACK_FILENAME2);
    const blob = yield response.blob();
    downloadBlobAsFile2(blob, filename);
    return response;
  });
}

// src/post-claims-search.ts
import { deserialise as deserialise4 } from "kitsu-core";
var POST_CLAIMS_SEARCH_PATH = "/v1/claims-searches";
function postDeserializedClaimsSearch(variables) {
  return __async(this, null, function* () {
    const responseJson = yield postClaimsSearches(variables);
    const claimsData = deserialise4(
      responseJson
    );
    return claimsData;
  });
}

// src/get-claims-filters.ts
import { deserialise as deserialise5 } from "kitsu-core";
var GET_CLAIMS_FILTERS_PATH = "/v1/claims-filters";
function getDeserializedClaimsFilters(variables) {
  return __async(this, null, function* () {
    const responseJson = yield getClaimsFilters(variables != null ? variables : {});
    return deserialise5(responseJson);
  });
}

// src/get-claims-filters-v2.ts
import { deserialise as deserialise6 } from "kitsu-core";
var GET_CLAIMS_FILTERS_V2_PATH = "/v2/claims-filters";
function getDeserializedClaimsFiltersV2(variables) {
  return __async(this, null, function* () {
    const responseJson = yield getClaimsFiltersV2(variables != null ? variables : {});
    return deserialise6(responseJson);
  });
}

// src/post-claims-search-v2.ts
import { deserialise as deserialise7 } from "kitsu-core";
var POST_CLAIMS_SEARCH_PATH_V2 = "/v2/claims-searches";
function postDeserializedClaimsSearchV2(variables) {
  return __async(this, null, function* () {
    const responseJson = yield postClaimsSearchesV2(variables);
    const claimsData = deserialise7(
      responseJson
    );
    return claimsData;
  });
}
export {
  GET_CLAIMS_FILTERS_PATH,
  GET_CLAIMS_FILTERS_V2_PATH,
  GET_CLAIMS_SUMMARY_MOCK_DATA,
  GET_CLAIMS_SUMMARY_MOCK_DATA_EMPTY,
  GET_CLAIMS_SUMMARY_PATH,
  GET_CLAIM_DETAILS_MOCK_DATA,
  GET_CLAIM_DETAILS_PATH,
  GET_DOWNLOAD_CLAIMS_SUMMARY_PATH,
  GET_DOWNLOAD_EXPLANATION_OF_BENEFITS_PATH,
  POST_CLAIMS_SEARCH_PATH,
  POST_CLAIMS_SEARCH_PATH_V2,
  getClaimDetails,
  getClaimEobFile,
  getClaimsFilters,
  getClaimsFiltersV2,
  getClaimsSummary,
  getClaimsSummaryFile,
  getClaimsSummaryMock,
  getDeserializedClaimDetails,
  getDeserializedClaimsFilters,
  getDeserializedClaimsFiltersV2,
  getDeserializedClaimsSummary,
  getDownloadClaimsSummary,
  getDownloadClaimsSummaryBlobAsFile,
  getDownloadExplanationOfBenefits,
  operationsByTag,
  postClaimsSearches,
  postClaimsSearchesV2,
  postDeserializedClaimsSearch,
  postDeserializedClaimsSearchV2
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/claims-api'] = window.leagueSDKsPresent['@leagueplatform/claims-api'] || [];
    window.leagueSDKsPresent['@leagueplatform/claims-api'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/claims-api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/claims-api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map